var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "message-container d-flex justify-content-begin mb-2 inbound",
    },
    [
      _c("div", { staticClass: "message" }, [
        _c("div", { staticClass: "header font-weight-bold" }, [
          _vm.contactFilemakerId
            ? _c("span", { staticClass: "contact-filemaker-id" }, [
                _vm._v(_vm._s(_vm.contactFilemakerId)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "contact-full-name" }, [
            _vm._v(_vm._s(_vm._f("uppercase")(_vm.contactFullName))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content d-flex flex-column", style: _vm.styles },
          [
            _c(
              "div",
              { staticClass: "content-body w-100 d-flex" },
              [
                _c("span", { staticClass: "message-content w-100" }, [
                  _vm._v(_vm._s(_vm.content)),
                ]),
                _vm._v(" "),
                _c("message-settings", {
                  attrs: { settings: _vm.settings, message: _vm.message },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasMedia
              ? _c("media-list", {
                  attrs: { media: _vm.media, "is-inbound": true },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer text-black-50" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm._f("uppercase")(_vm.statusString)) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _vm.isPreserved
            ? _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "light",
                    placement: "right",
                    content: "Message is preserved",
                  },
                },
                [_c("i", { staticClass: "fas fa-bookmark ml-1" })]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }